import { Component} from '@angular/core';
import { UserData } from '../../../../providers/user-data';
import { PageBase } from '../../../../core/page-base';
import { AppSettings } from '../../../../config/app-settings';
import { StoreInfoPage } from '../store-info/store-info';
import { StoreLocatorData } from '../../providers/store-locator-data';
import { NavController, Events, LoadingController, ActionSheetController, AlertController } from 'ionic-angular';
import { Utils } from '../../../../providers/utils';
@Component({
  selector: 'page-store-locator',
  templateUrl: 'store-locator.html'
})
export class StoreLocatorPage extends PageBase{
	public lstStores: any;
	public loader: any;
	public filteredItems: any;
	public pagedFilteredItems: any = []; 
	public pageSize: Number = 15;
	public hasMore = true;
	public currentStore: any = {};
	public centerPointsMap: any = {lat : 32.808053, lng: -96.771812};
	public mapZoom: number = 5;
	// google map settings
	private gMapRadius: number;
	private gMapCenterPointsDefault: any;
	private gMapZoom: number;
    constructor(
		public nav: NavController,
		public userData: UserData,
		public settings: AppSettings,
		public events: Events,
		public storeLocatorData: StoreLocatorData,	
		public actionsheetController: ActionSheetController,
        public loadingCtrl: LoadingController,
        public alertCtroller: AlertController,
	) {
		super(settings, events, nav, userData);
		this.loader = this.loadingCtrl.create();
		this.gMapCenterPointsDefault = this.settings.gMapCenterPointsDefault;
		this.centerPointsMap = this.settings.gMapCenterPointsDefault;
		this.gMapRadius = this.settings.gMapRadius;
		this.gMapZoom = this.settings.gMapZoom;
		this.mapZoom = this.settings.gMapZoom;
	}

	isMap: boolean = true;
	public loadPage(){
		let self = this;
		for (let i=0; i< this.pageSize; i++){
    		if(self.pagedFilteredItems.length >= self.filteredItems.length){
    			self.hasMore = false;
    			return;
    		}
			this.pagedFilteredItems.push(self.filteredItems[self.pagedFilteredItems.length]);
		}
	}

	public loadMoreItems(infiniteScroll) {
	    let self = this;
	    setTimeout(() => {
	    	self.loadPage();
			infiniteScroll.complete();
	    }, 500);
	
	}

	public initPage(){
		let self = this;
		self.loader = this.loadingCtrl.create();
		self.loader.present();
		  self.storeLocatorData.searchStore('','distance').subscribe((stores)=>{
			if(!stores){
				return;
			}
			if(stores.length > 0){
				var defaultStore = stores[0];
				self.centerPointsMap.lat = defaultStore.latitude;
				self.centerPointsMap.lng = defaultStore.longitude;
				self.mapZoom = self.gMapZoom;
			}
			self.loadStoresData(stores);
		});
	}

	public loadStoresData(data){
		let self = this;
		self.lstStores = Utils.toArray(data).reverse();
		self.filteredItems = self.lstStores;
		this.pagedFilteredItems = [];
		self.loadPage();
		self.loader.dismiss();
	}

	mapView(){
		this.isMap = true;
	}

	listView(){
		this.isMap = false;
	}

	nearBy(){
		let self = this;
		self.isMap = true;
		self.loader = this.loadingCtrl.create();
		self.loader.present();
		self.storeLocatorData.getCurrentPosition().subscribe((res:any) => { 
			console.log(res);
			var latlgn = '';
			if(res){
				if(res.latitude && res.longitude){
					latlgn = res.latitude &&  res.longitude ? res.latitude+ ',' + res.longitude : '';
					self.centerPointsMap.lat = res.latitude;
					self.centerPointsMap.lng = res.longitude;
					self.mapZoom = self.gMapZoom + 3;
				}
			}
			self.storeLocatorData.getStoreByCoords(latlgn).subscribe((stores)=>{
				if(stores){
					self.loadStoresData(stores);
				}
			});
		},(error:any) => {
			self.loader.dismiss();
			if(error){
				self.alertCtroller.create({
					title: 'Store Locator',
					message : error.message
				});
			}
			else {
				self.alertCtroller.create({
					title: 'Store Locator',
					message : 'Please enable location service.'
				});
			}
		});
	}

	searchStores(event){
		let self = this;
		var keyword = event.target.value || '';
		keyword = keyword.trim();
		self.loader = this.loadingCtrl.create();
		self.loader.present();
	    self.storeLocatorData.searchStore(keyword).subscribe((stores)=>{
			if(!stores){
				return;
			}
			if(stores.length > 0){
				var defaultStore = stores[0];
				self.centerPointsMap.lat = defaultStore.latitude;
				self.centerPointsMap.lng = defaultStore.longitude;
				self.mapZoom = self.gMapZoom;
			}
			self.loadStoresData(stores);
			
		});
	}

	ngAfterViewInit() {
		
	}

	ionViewDidEnter() {
		this.initPage();
	}
	
	viewStore(id){
		this.nav.push(StoreInfoPage, {id: id});
	}
}



// WEBPACK FOOTER //
// ./src/modules/store-locator/pages/store-locator/store-locator.ts